import GenerateCode from "./GenerateCode";
import ValidateCode from "./ValidateCode";
import Complete from "./Complete";


export const SignUp = {
  GenerateCode,
  ValidateCode,
  Complete,
};
